import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { registerSW } from 'virtual:pwa-register'

// Render immediately to avoid mixed React runtimes or delayed dispatcher setup
const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register PWA service worker with auto-update
registerSW({
  onNeedRefresh() {
    // New content available, will auto-update on next visit
    console.log('New content available, refresh for updates');
  },
  onOfflineReady() {
    console.log('App ready to work offline');
  },
});
